const { isValid, isExpirationDateValid, isSecurityCodeValid, getCreditCardNameByNumber } = require('creditcard.js');

class CreditcardService {
  static isValidCreditcard(creditcardNumber) {
    if (typeof creditcardNumber !== 'string') {
      creditcardNumber = String(creditcardNumber);
    }

    return isValid(creditcardNumber);
  }

  static isValidExpirationDate(month, year) {
    if (typeof month !== 'string') {
      month = String(month);
    }

    if (typeof year !== 'string') {
      year = String(year);
    }

    return isExpirationDateValid(month, year);
  }

  static isValidSecurityCode(creditcardNumber, securityCode) {
    if (typeof creditcardNumber !== 'string') {
      creditcardNumber = String(creditcardNumber);
    }

    if (typeof securityCode !== 'string') {
      securityCode = String(securityCode);
    }

    return isSecurityCodeValid(creditcardNumber, securityCode);
  }

  static getCreditCardNameByNumber(creditcardNumber) {
    if (typeof creditcardNumber !== 'string') {
      creditcardNumber = String(creditcardNumber);
    }

    return getCreditCardNameByNumber(creditcardNumber);
  }
}

module.exports = CreditcardService;
